import React from 'react';
import Index from './Index';
import AccountingSettingsView from '../components/views/AccountingSettingsView';
import { modules } from '../config/const';

function AccountingSettingsPage() {
  return <Index content={AccountingSettingsView} module={modules.AccountingSettings} />;
}

export default AccountingSettingsPage;
